import { render, staticRenderFns } from "./schedule-reminder-summary.vue?vue&type=template&id=9f208940&"
import script from "./schedule-reminder-summary.vue?vue&type=script&lang=js&"
export * from "./schedule-reminder-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports